<template>
<div class="chapter">
<div class="inner_page">
<p class="head">CONTENTS</p>
<p class="toc1"><a href="#/foreword">Foreword</a></p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter1">Stark County, Ohio</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">Life on the Frontier</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">Beyond the Towpath</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">The Underground Railroad</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">Bury the Dead</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">Hang ’Em High</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">The Great Influenza Epidemic of 1917–18</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">Dining with the Dead—Spirits Anyone?</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample">Haunted History with Style</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Ghosts on Film and Radio</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Stark Frights</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Dowsing for Graves</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Got Ghosts?</span></p>
<p class="toc1"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?17a34f67